import { MenuItem, MenuItemProps } from '@mui/material';
import Checkbox from './checkbox';

type CheckboxSelectItemProps = MenuItemProps & {
  checked: boolean;
};

const CheckboxSelectItem: React.FC<CheckboxSelectItemProps> = ({ checked, children, ...props }) => {
  return (
    <MenuItem {...props}>
      <Checkbox dark hiddenLabel checked={checked} />
      {children}
    </MenuItem>
  );
};

export default CheckboxSelectItem;
